import { Icon, PageTitle } from '@pwc/pwc-deals-ui';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import ModalConfirmation from 'common/components/ModalConfirmation';
// eslint-disable-next-line import/extensions
import { createCustomAnalysisPath } from 'common/services/urlService';
import './AddAnalysisType.scss';
import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import StructuredAnalysisMFE from '../../../mfe/structuredAnalysis/StructuredAnalysisMFE';

import {
  getProjectLoading,
  isStructuredV2Enabled,
} from '../../project/projectSlice';
import { StructuredV1 } from './components/StructuredV1';

const AddAnalysisType = () => {
  const [tempRedirect, setTempRedirect] = useState(null);
  const { projectId } = useParams();
  const history = useHistory();
  const isFakeClientUser = useSelector(getFakeClientUser);
  if (isFakeClientUser) {
    history.push('/projects');
  }
  const createCustomAnalysisHref = createCustomAnalysisPath(projectId);

  const isLoading = useSelector(getProjectLoading);
  const enableStructuredV2 = useSelector(isStructuredV2Enabled);

  const [isRaceErrorVisible, setRaceError] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    window.openSa1 = () => setTempRedirect(true);
    window.openSa2 = () => setTempRedirect(false);
  }, []);

  useEffect(() => {
    const { location } = history;
    if (location.state && location.state.autoSaveError) {
      setRaceError(true);
      history.replace({ state: {} });
    }
  }, [history]);

  const getStructured = () => {
    if (isLoading) return null;

    if (tempRedirect === true) {
      return <StructuredV1 />;
    }
    if (tempRedirect === false) {
      return <StructuredAnalysisMFE />;
    }

    return enableStructuredV2 ? <StructuredAnalysisMFE /> : <StructuredV1 />;
  };

  return (
    <>
      <ModalConfirmation
        show={isRaceErrorVisible}
        showCancel={false}
        onCancel={() => setRaceError(false)}
        onConfirm={() => window.location.reload()}
        confirmTitle="Unable to add a Structured Analysis as it has already created."
        confirmationMessage="Please refresh the page or try again later."
        confirmButtonText="Refresh page"
        dialogClassName="modal-confirmation"
        contentClassName="modal-confirmation"
      />
      <div className="add-analysis-type-container">
        <PageTitle title={t('addNewAnalysis')} size="h1" />

        <section className="custom-analysis-section">
          <PageTitle title={t('custom')} size="h2" />

          <p>{t('buildAndCustomiseLayoutData')}</p>

          <Link to={createCustomAnalysisHref} data-testid="create-new-custom">
            <Icon name="add" width={18} />
            {t('newCustom')}
          </Link>
        </section>
        {getStructured()}
      </div>
    </>
  );
};

export default AddAnalysisType;
